import React from 'react'

export const Forms = props => {

  return <div 
    { ...props.attribs }
  >
    El form
  </div>
}
